import React, { ReactElement, useEffect, useState } from 'react';
import './PersonView.scss';
import TopBarProgress from 'react-topbar-progress-indicator';
import PersonViewNav from './PersonViewNav';
import PersonDetails from './PersonDetails';
import { desktopMediaQuery } from '../../helpers/mediaQueries';
import { PersonAPI } from '../../api';
import { SEOHead } from '../../components/head/SEOHead';

type PersonProps = {
  electedPositionId: number;
};

const PersonView = (props: PersonProps): ReactElement => {
  const { electedPositionId } = props;
  const [isDesktopScreen, setIsDesktopScreen] = useState(desktopMediaQuery.matches);
  const { data: person, isError } =
    PersonAPI.endpoints.getPerson.useQuery(electedPositionId);

  const handleResize = (): void => {
    setIsDesktopScreen(desktopMediaQuery.matches);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const electedPosition =
    person?.electedPositions && person.electedPositions.find((ep) => ep.isActive);

  const descriptionDetail = electedPosition
    ? ` - ${electedPosition?.jurisdiction.name} ${electedPosition?.role} in district ${electedPosition?.district}`
    : '';
  const titleDetail = electedPosition
    ? ` - ${electedPosition?.jurisdiction.name} ${electedPosition?.role}`
    : '';
  return (
    <div className="container-fluid person-view">
      <SEOHead
        description={`Details on ${person?.name}${descriptionDetail}`}
        title={`${person?.name}${titleDetail}`}
      />
      {isError && (
        <div className="message-card">
          We are having trouble loading this data, sorry!
        </div>
      )}
      {!person && !isError && (
        <>
          <TopBarProgress />
          <div className="message-card">Loading...</div>
        </>
      )}
      {person && (
        <div className="row">
          {isDesktopScreen && (
            <div className="col-lg-3 d-flex" style={{ paddingLeft: '0px' }}>
              <PersonDetails person={person} />
            </div>
          )}
          <div className="col-12 col-lg-9 p-0">
            <PersonViewNav electedOfficialId={electedPositionId} person={person} />
          </div>
        </div>
      )}
    </div>
  );
};

export default PersonView;
